/* eslint-disable */
import Results from "@/components/dashboard/charts/ResultsChart.vue";
import BarChart from "@/components/dashboard/charts/BarChart.vue";
import PieChart from "@/components/dashboard/charts/PieChart.vue";
import RadialChart from "@/components/dashboard/charts/RadialChart.vue";
import StackedBarChart from "@/components/dashboard/charts/StackedBarChart.vue";
import LineChart from "@/components/dashboard/charts/LineChart.vue";
import AreaChart from "@/components/dashboard/charts/AreaChart.vue";

import CategoryTopic from "@/components/dashboard/viz/CategoryTopic.vue";
import WordCloud from "@/components/dashboard/viz/WordCloud.vue";
import VisNetwork from "@/components/dashboard/viz/VisNetwork.vue";
import MapsMarker from "@/components/dashboard/viz/MapsMarker.vue";
import MapsHeat from "@/components/dashboard/viz/MapsHeat.vue";
import VectorMap from "@/components/dashboard/viz/VectorMap.vue";
/* eslint-enable */
export default {
    /* eslint-disable */
    components: {
        Results,
        BarChart,
        PieChart,
        RadialChart,
        StackedBarChart,
        LineChart,
        AreaChart,
        CategoryTopic,
        WordCloud,
        VisNetwork,
        MapsMarker,
        MapsHeat,
        VectorMap
    },
    /* eslint-enable */
    props: {
        dashboardData: {
            type: Object,
            default: undefined,
        },
        filterOptions: {
            type: Object,
            default: () => { }
        }
    },
    methods: {
        filter(filter) {
            this.$emit("filter", filter);
        },
        select(select) {
            this.$emit("select", select);
        }
    }
};